import { render, staticRenderFns } from "./ErrandList.vue?vue&type=template&id=a35f0326&scoped=true&"
import script from "./ErrandList.vue?vue&type=script&lang=js&"
export * from "./ErrandList.vue?vue&type=script&lang=js&"
import style0 from "./ErrandList.vue?vue&type=style&index=0&id=a35f0326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35f0326",
  null
  
)

export default component.exports